<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M3.75,24c-1.241,0-2.25-1.009-2.25-2.25V12C0.673,12,0,11.327,0,10.5V8.25C0,7.009,1.009,6,2.25,6h4.459
		C4.856,4.7,3.75,2.78,3.75,0.75C3.75,0.336,4.086,0,4.5,0c3.222,0,6.975,2.446,7.449,6h0.102c0.474-3.554,4.227-6,7.449-6
		c0.414,0,0.75,0.336,0.75,0.75c0,2.03-1.106,3.95-2.959,5.25h4.459C22.991,6,24,7.009,24,8.25v2.25c0,0.827-0.673,1.5-1.5,1.5v9.75
		c0,1.241-1.009,2.25-2.25,2.25H3.75z M20.25,22.5c0.414,0,0.75-0.336,0.75-0.75V12h-6v10.5H20.25z M13.5,22.5V12h-3v10.5H13.5z
		 M3,21.75c0,0.414,0.336,0.75,0.75,0.75H9V12H3V21.75z M22.5,10.5V8.25c0-0.414-0.336-0.75-0.75-0.75H15v3H22.5z M13.5,10.5v-3h-3
		v3H13.5z M2.25,7.5C1.836,7.5,1.5,7.836,1.5,8.25v2.25H9v-3H2.25z M18.659,1.557c-2.724,0.363-4.644,2.419-5.068,4.386
		C16.315,5.58,18.235,3.524,18.659,1.557z M5.341,1.557c0.425,1.967,2.345,4.022,5.069,4.386C9.985,3.976,8.065,1.92,5.341,1.557z"
		/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'gift-box',
    },
    name: {
      type: String,
      required: false,
      default: 'GiftBox',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>